<template>
  <div v-if="!selecionouCideCombustivel">
    <div class="cide_container" v-for="registro in imposto.dados">
      <RadioButton
        v-if="imposto.dados.length > 1"
        :seleciona="seleciona"
        :imposto="registro"
        :classe="imposto.classe"
      />
      <Registro :paddingSemCheckBox="imposto.dados.length <= 1">
        <Cabecalho :tipo="'ncm'" :titulo="registro.label" :aliquota="registro.medida_aplicada" />
        <div class="separador" />

        <Ncm :ncm="registro.ncm" />
        <div class="separador" />

        <Descricao :titulo="'Descrição'" :descricao="registro.descricao" />
        <GrupoNotificacao v-if="registro" :registro="registro" />

        <div class="separador" />

        <BaseLegal :base_legal="registro.base_legal" :classe="imposto.classe" />
      </Registro>
    </div>
  </div>

  <div v-else>
    <div class="cide_container">
      <EditButton v-if="imposto.dados.length > 1" :edita="edita" :classe="imposto.classe" />
      <Registro :paddingSemCheckBox="imposto.dados.length <= 1">
        <Cabecalho
          :tipo="'ncm'"
          :titulo="registroSelecionado.label"
          :aliquota="registroSelecionado.medida_aplicada"
        />
        <div class="separador" />

        <Ncm :ncm="registroSelecionado.ncm" />
        <div class="separador" />

        <Descricao :titulo="'Descrição'" :descricao="registroSelecionado.descricao" />
        <GrupoNotificacao v-if="registroSelecionado" :registro="registroSelecionado" />

        <div class="separador" />

        <BaseLegal :base_legal="registroSelecionado.base_legal" :classe="imposto.classe" />
      </Registro>
    </div>
  </div>
</template>

<script>
import BaseLegal from "@/components/BaseLegal/BaseLegal.vue";
import Cabecalho from "@/components/Cabecalho/Cabecalho.vue";
import Descricao from "@/components/Descricao/Descricao.vue";
import EditButton from "@/components/Button/EditButton.vue";
import Ncm from "@/components/Ncm/Ncm.vue";
import Notificacao from "@/components/Notificacao/Notificacao.vue";
import RadioButton from "@/components/Button/RadioButton.vue";
import Registro from "@/components/Registro/Registro.vue";
import GrupoNotificacao from "@/components/GrupoNotificacao/GrupoNotificacao.vue";

export default {
  name: "RegistrosCideCombustivel",

  props: {
    edita: Function,
    imposto: Array | Object,
    registroSelecionado: Object,
    seleciona: Function,
    selecionouCideCombustivel: Boolean
  },

  components: {
    Cabecalho,
    BaseLegal,
    GrupoNotificacao,
    Descricao,
    EditButton,
    Ncm,
    Notificacao,
    RadioButton,
    Registro
  },

  data() {
    return {};
  },

  created() {
    if (this.imposto.dados.length == 1) {
      this.seleciona(this.imposto.dados[0]);
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.cide_container {
  display: flex;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
}
</style>
